import getErrorMessages from "./error";
import getSuccessMessages from "./success";
/**
 * Middleware that dispatches success/error message actions in response to identity request
 * successes/failures. This is optional and may or may not make sense givin your use case.
 * MyNerdwallet/CreditDashboard and the Auth Dialog use this to show toastr messages.
 * @name createMessagesMiddleware
 * @param  {function}   successAction Action creator in the formation `(successMessage) => {...}`
 * @param  {function}   errorAction Action creator in the formation `(errorMessage) => {...}`
 * @return {function} Instance of redux middleware
 *
 * @example <caption>Implemenation using redux toastr</caption>
 * import { actions as toastrActions } from 'react-redux-toastr'
 * import { createMessagesMiddleware } from '@nerdwallet/js-auth-tools/dist/middleware'
 *
 * // success/error actions will be dispatched with message
 * // e.g. dispatch(success(message))
 * const messagesMiddleware = createMessagesMiddleware(toastrActions.success, toastrActions.error)
 *
 * // assumes you have an array of middleware defined previously
 * middlewares.push(messagesMiddleware)
 */

export default (function (successAction, errorAction) {
  return function (_ref) {
    var dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (typeof successAction !== 'function' || typeof errorAction !== 'function') {
          throw new Error('Messages middleware requires success and error action creator functions');
        } // SUCCESS MESSAGES


        var successMessage = getSuccessMessages(null, action);
        if (successMessage) dispatch(successAction(successMessage)); // ERROR MESSAGES

        var errorMessage = getErrorMessages(null, action);
        if (errorMessage) dispatch(errorAction(errorMessage));
        return next(action);
      };
    };
  };
});
export { default as getErrorMessages } from "./error";
export { default as getSuccessMessages } from "./success";